import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum FrequencyStatusesEnum {
    InActive = 0,
    Active = 1,
    Discontinued = 2
}

class FrequencyStatusesClass extends EnumWithDescription<FrequencyStatusesEnum> {
    public readonly enum = FrequencyStatusesEnum;
    public readonly enumName: string = "FrequencyStatusesEnumm";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<FrequencyStatusesEnum>> = new Map([
        [
            "InActive",
            {
                name: "Inactive",
                value: FrequencyStatusesEnum.InActive
            }
        ],
        [
            "Active",
            {
                name: "Active",
                value: FrequencyStatusesEnum.Active
            }
        ],
        [
            "Discontinued",
            {
                name: "Discontinued",
                value: FrequencyStatusesEnum.Discontinued
            }
        ]
    ]);
}

export const FrequencyStatuses = new FrequencyStatusesClass();
